import { FormControlChangeListener } from "./form-manager";
import { InputControl } from "./input-control";

export class DateInput extends InputControl {

    formatValue() {
        // Convert from yyyy-mm-dd to mm/dd/yyyy
        const value = this.getValue();
        if (!value) { 
            return ''; 
        } 
        const [year, month, day] = value.split('-');
        return `${month}/${day}/${year}`;
    }

    addChangeListener(onChange: FormControlChangeListener): void {
        let input = this.element;
        let changeCallback = () => onChange(this);
        let blurCallback = () => {
            input.removeEventListener('blur', blurCallback);
            input.addEventListener('change', changeCallback);
            changeCallback();
        };

        input.addEventListener('change', changeCallback);
        // If the user chooses to type in the date, we wait until they click away 
        input.addEventListener('keypress', function (e) {
            input.removeEventListener('change', changeCallback);
            input.addEventListener('blur', blurCallback);
        });
    }
}
